import {
  consumeProvisionalExternalTab,
  beginProvisionalNavigation,
} from 'utils/safari-external-link-provisional';

/**
 * Vendor landing pages (Active&Fit Direct, ChooseHealthy) resolve the client
 * specific experience from the Referer header, so `rel` must stay free of
 * `noreferrer` — without it the member lands on the public homepage and
 * cannot enrol. See CIG-10325.
 */
export const handleExternalLink = (
  url: string,
  target?: string,
): Promise<void> => {
  const win = consumeProvisionalExternalTab();
  const tabTarget = target ?? '_blank';
  if (win && !win.closed && tabTarget === '_blank') {
    beginProvisionalNavigation(win, url);
    return Promise.resolve();
  }

  const a = document.createElement('a');
  a.href = url;
  a.target = tabTarget;
  a.rel = 'noopener';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  a.remove();
  return Promise.resolve();
};
